import UnimplementedError from '../../../../../../exception/unimplementedError';

export default class SetupStrategy {
  constructor(logger, store, eventBus, di, memberService, router) {
    this.logger = logger;
    this.store = store;
    this.eventBus = eventBus;
    this.di = di;
    this.memberService = memberService;
    this.router = router;
    this.vm = null;

    this.windowHandle = null;
    this.checkWindowHandle = null;
    this.bailOutHandle = null;
    this.vendor = 'override me';
    this.requiresLogin = false;
  }

  properName() {
    this.logger.capture(new UnimplementedError());
  }

  setVm(vm) {
    this.vm = vm;
  }

  openDeviceLinkingWindow(credentials) {
    let url = this.getDeviceLinkingUrl();
    if (credentials) {
      const urlParams = new URLSearchParams();
      urlParams.append('email', credentials.username);
      urlParams.append('password', credentials.password);
      url += `&${urlParams.toString()}`;
    }
    this.windowHandle = window.open(url);


    // TODO: take this out when RHF ends
    this.bailOutHandle = setTimeout(() => {
      clearInterval(this.checkWindowHandle);
      this.checkWindowHandle = null;
      this.bailOut(true, () => {
        if (window.location.pathname.includes('custom')) {
          this.router.push({
            name: 'RHFConnections',
          });
        } else {
          this.router.push({
            name: 'profile',
          });
        }
      });
    }, 1000 * 45);

    this.checkWindowHandle = setInterval(() => {
      if (this.windowHandle.closed) {
        this.bailOut(!this.store.state.member.loggedInMember[`${this.vendor}Linked`], this.vm.deviceTabChange.reject);
        clearInterval(this.checkWindowHandle);
        this.checkWindowHandle = null;
        clearTimeout(this.bailOutHandle);
        this.bailOutHandle = null;
      }
    }, 1000);
  }

  bailOut(condition, callback) {
    console.log('Bailing out');
    this.store.dispatch('refreshMember').then(() => {
      if (condition) {
        this.vm.stopWaiting();
        callback();
      }
    });
  }

  handleRetryLogin() {
    this.logger.log('Unimplemented for this device type');
  }

  getDeviceLinkingUrl() {
    this.logger.capture(new UnimplementedError());

    return 'Not implemented';
  }
}
